import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule, Panel, InputTextModule, TabViewModule, OverlayPanelModule,DropdownModule, TreeModule, TreeTableModule } from 'primeng/primeng';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { ReportManagementComponent } from './report-management/report-management.component';
import { ReportsComponent } from './report-management/reports/reports.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LookupService } from '../services/lookups/lookup.service';
import { UsersListComponent } from './user-management/users-list/users-list.component';
import { TableModule } from 'primeng/table';
import { RegistrationService } from '../services/registration.service';
import { ReportService } from '../services/report.service';
import { NotifierService } from 'angular-notifier';
import { RptstatusmgmtComponent } from './report-management/rptstatusmgmt/rptstatusmgmt.component';
import { DialogModule } from 'primeng/dialog';
import { LookupManagementComponent } from './lookup-management/lookup-management.component';
import { CountryComponent } from './lookup-management/country/country.component';
import { PostComponent } from './lookup-management/post/post.component';
import { ProgramAreaComponent } from './lookup-management/programarea/programarea.component';
import { DivisionComponent } from './lookup-management/division/division.component';
import { ReportCategoryComponent } from './lookup-management/reportcategory/reportcategory.component';
import { LookupAdminService } from '../services/lookups/lookupadmin.service';
import { PostDetailComponent } from './lookup-management/post/post-detail/post-detail.component';
import { CountryDetailComponent } from './lookup-management/country/country-detail/country-detail.component';
import { ProgramAreaDetailComponent } from './lookup-management/programarea/programarea-detail/programarea-detail.component';
import { DivisionDetailComponent } from './lookup-management/division/division-detail/division-detail.component';
import {ContextMenuModule} from 'primeng/contextmenu';
import { ReportcategoryDetailComponent } from './lookup-management/reportcategory/reportcategory-detail/reportcategory-detail.component';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { DashboardComponent } from './reports-dashboard/dashboard/dashboard.component';
import { CustomReportsComponent } from './reports-dashboard/custom-reports/custom-reports.component';
import {HighchartsChartModule} from 'highcharts-angular';
import { ReportsTotalCountCardComponent } from './reports-dashboard/dashboard/reports-total-count-card/reports-total-count-card.component';
import { AnalyticsService } from '../services/analytics.service';
 
import { ListboxModule } from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import {SelectButtonModule} from 'primeng/selectbutton';
import { ReportCountsFiveYearCardComponent } from './reports-dashboard/dashboard/report-counts-five-year-card/report-counts-five-year-card.component';
import { ReportsCountByStatusCardComponent } from './reports-dashboard/dashboard/reports-count-by-status-card/reports-count-by-status-card.component';
import { ReportCountByTypeCardComponent } from './reports-dashboard/dashboard/report-count-by-type-card/report-count-by-type-card.component';
import { ReportDownloadCountsComponent } from './reports-dashboard/custom-reports/report-download-counts/report-download-counts.component';
import { ReportVarianceDueDateComponent } from './reports-dashboard/custom-reports/report-variance-due-date/report-variance-due-date.component';
import { ReportSubmittedByPostComponent } from './reports-dashboard/custom-reports/report-submitted-by-post/report-submitted-by-post.component';



@NgModule({
  declarations: [
    AdminComponent,
    ReportManagementComponent,
    ReportsComponent,
    UserManagementComponent,
    UsersListComponent,
    RptstatusmgmtComponent,
    LookupManagementComponent,
    CountryComponent,
    PostComponent,
    ProgramAreaComponent,
    DivisionComponent,
    ReportCategoryComponent,
    PostDetailComponent,
    CountryDetailComponent,
    ProgramAreaDetailComponent,
    DivisionDetailComponent,
    ReportcategoryDetailComponent,
    ReportsDashboardComponent,
    DashboardComponent,
    CustomReportsComponent,
    ReportsTotalCountCardComponent,
    ReportCountsFiveYearCardComponent,
    ReportsCountByStatusCardComponent,
    ReportCountByTypeCardComponent,
    ReportDownloadCountsComponent,
    ReportVarianceDueDateComponent,
    ReportSubmittedByPostComponent        
  ],
  imports: [CommonModule, 
           AdminRoutingModule, 
           RadioButtonModule, 
           FormsModule,
           ReactiveFormsModule, 
           TableModule,
           TabViewModule,
           DropdownModule,
           ListboxModule,
           MultiSelectModule,
           DialogModule,
           TreeModule,
           TreeTableModule,
           ContextMenuModule,
           HighchartsChartModule,
          CalendarModule,
          SelectButtonModule],
  providers: [LookupService,
              LookupAdminService,
              RegistrationService, 
              NotifierService,
              ReportService,
              AnalyticsService]
})
export class AdminModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts